const columns: any = [
  {
    title: 'Service',
    field: 'service',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Sub Service',
    field: 'subService',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Tender Type',
    field: 'tenderType',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Operation region',
    field: 'operationRegion',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Mode',
    field: 'modes',
    headerStyle: { zIndex: 11 }
  }
];

export default columns;
